export const countriesByRegion = [
  {
    name: 'North America',
    countries: [
    { code: 'BM', name: 'Bermuda' },
    { code: 'CA', name: 'Canada' },
    { code: 'GL', name: 'Greenland' },
    { code: 'PM', name: 'Saint Pierre and Miquelon' },
    { code: 'US', name: 'United States' }
    ]
  },
  {
    name: 'Central/South America',
    countries: [
      { code: 'AR', name: 'Argentina' },
      { code: 'BZ', name: 'Belize' },
      { code: 'BO', name: 'Bolivia' },
      { code: 'BV', name: 'Bouvet Island' },
      { code: 'BR', name: 'Brazil' },
      { code: 'CL', name: 'Chile' },
      { code: 'CO', name: 'Colombia' },
      { code: 'CR', name: 'Costa Rica' },
      { code: 'EC', name: 'Ecuador' },
      { code: 'SV', name: 'El Salvador' },
      { code: 'FK', name: 'Falkland Islands (Malvinas)' },
      { code: 'GF', name: 'French Guiana' },
      { code: 'GT', name: 'Guatemala' },
      { code: 'GY', name: 'Guyana' },
      { code: 'HN', name: 'Honduras' },
      { code: 'MX', name: 'Mexico' },
      { code: 'NI', name: 'Nicaragua' },
      { code: 'PA', name: 'Panama' },
      { code: 'PY', name: 'Paraguay' },
      { code: 'PE', name: 'Peru' },
      { code: 'GS', name: 'South Georgia and the South Sandwich Islands' },
      { code: 'SR', name: 'Suriname' },
      { code: 'UY', name: 'Uruguay' },
      { code: 'VE', name: 'Venezuela' }
    ]
  },
  {
    name: 'Caribbean',
    countries: [
      { code: 'AI', name: 'Anguilla' },
      { code: 'AG', name: 'Antigua and Barbuda' },
      { code: 'AW', name: 'Aruba' },
      { code: 'BS', name: 'Bahamas' },
      { code: 'BB', name: 'Barbados' },
      { code: 'BQ', name: 'Bonaire (Saint Eustatius and Saba)' },
      { code: 'KY', name: 'Cayman Islands' },
      { code: 'CU', name: 'Cuba' },
      { code: 'CW', name: 'Curacao' },
      { code: 'DM', name: 'Dominica' },
      { code: 'DO', name: 'Dominican Republic' },
      { code: 'GD', name: 'Grenada' },
      { code: 'GP', name: 'Guadeloupe' },
      { code: 'HT', name: 'Haiti' },
      { code: 'JM', name: 'Jamaica' },
      { code: 'MQ', name: 'Martinique' },
      { code: 'MS', name: 'Montserrat' },
      { code: 'PR', name: 'Puerto Rico' },
      { code: 'BL', name: 'Saint Bartelemey' },
      { code: 'KN', name: 'Saint Kitts and Nevis' },
      { code: 'LC', name: 'Saint Lucia' },
      { code: 'MF', name: 'Saint Martin' },
      { code: 'VC', name: 'Saint Vincent and the Grenadines' },
      { code: 'SX', name: 'Sint Maarten' },
      { code: 'TT', name: 'Trinidad and Tobago' },
      { code: 'TC', name: 'Turks and Caicos Islands' },
      { code: 'VG', name: 'Virgin Islands (British)' },
      { code: 'VI', name: 'Virgin Islands (U.S.)' }
    ]
  },
  {
    name: 'European Union',
    countries: [
      { code: 'AT', name: 'Austria' },
      { code: 'BE', name: 'Belgium' },
      { code: 'BG', name: 'Bulgaria' },
      { code: 'HR', name: 'Croatia' },
      { code: 'CY', name: 'Cyprus' },
      { code: 'CZ', name: 'Czech Republic' },
      { code: 'DK', name: 'Denmark' },
      { code: 'EE', name: 'Estonia' },
      { code: 'FI', name: 'Finland' },
      { code: 'FR', name: 'France' },
      { code: 'DE', name: 'Germany' },
      { code: 'GR', name: 'Greece' },
      { code: 'HU', name: 'Hungary' },
      { code: 'IE', name: 'Ireland' },
      { code: 'IT', name: 'Italy' },
      { code: 'LV', name: 'Latvia' },
      { code: 'LT', name: 'Lithuania' },
      { code: 'LU', name: 'Luxembourg' },
      { code: 'MT', name: 'Malta' },
      { code: 'NL', name: 'Netherlands' },
      { code: 'PL', name: 'Poland' },
      { code: 'RO', name: 'Romania' },
      { code: 'SK', name: 'Slovakia' },
      { code: 'SI', name: 'Slovenia' },
      { code: 'ES', name: 'Spain' },
      { code: 'SE', name: 'Sweden' },
      { code: 'GB', name: 'United Kingdom' }
    ]
  },
  {
    name: 'Europe (Non-EU)',
    countries: [
      { code: 'AX', name: 'Aland Islands' },
      { code: 'AL', name: 'Albania' },
      { code: 'AD', name: 'Andorra' },
      { code: 'BY', name: 'Belarus' },
      { code: 'BA', name: 'Bosnia and Herzegovina' },
      { code: 'EU', name: 'Europe' },
      { code: 'FO', name: 'Faroe Islands' },
      { code: 'GI', name: 'Gibraltar' },
      { code: 'GG', name: 'Guernsey' },
      { code: 'VA', name: 'Holy See (Vatican City State)' },
      { code: 'IS', name: 'Iceland' },
      { code: 'IM', name: 'Isle of Man' },
      { code: 'JE', name: 'Jersey' },
      { code: 'LI', name: 'Liechtenstein' },
      { code: 'MK', name: 'Macedonia' },
      { code: 'MD', name: 'Moldova, Republic of' },
      { code: 'MC', name: 'Monaco' },
      { code: 'ME', name: 'Montenegro' },
      { code: 'NO', name: 'Norway' },
      { code: 'PT', name: 'Portugal' },
      { code: 'RU', name: 'Russian Federation' },
      { code: 'SM', name: 'San Marino' },
      { code: 'RS', name: 'Serbia' },
      { code: 'SJ', name: 'Svalbard and Jan Mayen' },
      { code: 'CH', name: 'Switzerland' },
      { code: 'UA', name: 'Ukraine' }
    ]
  },
  {
    name: 'Asia/Pacific',
    countries: [
      { code: 'AF', name: 'Afghanistan' },
      { code: 'AS', name: 'American Samoa' },
      { code: 'AM', name: 'Armenia' },
      { code: 'AP', name: 'Asia/Pacific Region' },
      { code: 'AU', name: 'Australia' },
      { code: 'AZ', name: 'Azerbaijan' },
      { code: 'BD', name: 'Bangladesh' },
      { code: 'BT', name: 'Bhutan' },
      { code: 'BN', name: 'Brunei Darussalam' },
      { code: 'KH', name: 'Cambodia' },
      { code: 'CN', name: 'China' },
      { code: 'CX', name: 'Christmas Island' },
      { code: 'CC', name: 'Cocos (Keeling) Islands' },
      { code: 'CK', name: 'Cook Islands' },
      { code: 'FJ', name: 'Fiji' },
      { code: 'PF', name: 'French Polynesia' },
      { code: 'GE', name: 'Georgia' },
      { code: 'GU', name: 'Guam' },
      { code: 'HM', name: 'Heard Island and McDonald Islands' },
      { code: 'HK', name: 'Hong Kong' },
      { code: 'IN', name: 'India' },
      { code: 'ID', name: 'Indonesia' },
      { code: 'JP', name: 'Japan' },
      { code: 'KZ', name: 'Kazakhstan' },
      { code: 'KI', name: 'Kiribati' },
      { code: 'KP',
        name: 'Korea, (Democratic People\'s Republic of)' },
      { code: 'KR', name: 'Korea, (Republic of)' },
      { code: 'KG', name: 'Kyrgyzstan' },
      { code: 'LA', name: 'Lao People\'s Democratic Republic' },
      { code: 'MO', name: 'Macao' },
      { code: 'MY', name: 'Malaysia' },
      { code: 'MV', name: 'Maldives' },
      { code: 'MH', name: 'Marshall Islands' },
      { code: 'FM', name: 'Micronesia, Federated States of' },
      { code: 'MN', name: 'Mongolia' },
      { code: 'MM', name: 'Myanmar' },
      { code: 'NR', name: 'Nauru' },
      { code: 'NP', name: 'Nepal' },
      { code: 'NC', name: 'New Caledonia' },
      { code: 'NZ', name: 'New Zealand' },
      { code: 'NU', name: 'Niue' },
      { code: 'NF', name: 'Norfolk Island' },
      { code: 'MP', name: 'Northern Mariana Islands' },
      { code: 'PK', name: 'Pakistan' },
      { code: 'PW', name: 'Palau' },
      { code: 'PG', name: 'Papua New Guinea' },
      { code: 'PH', name: 'Philippines' },
      { code: 'PN', name: 'Pitcairn' },
      { code: 'WS', name: 'Samoa' },
      { code: 'SG', name: 'Singapore' },
      { code: 'SB', name: 'Solomon Islands' },
      { code: 'LK', name: 'Sri Lanka' },
      { code: 'TW', name: 'Taiwan' },
      { code: 'TJ', name: 'Tajikistan' },
      { code: 'TH', name: 'Thailand' },
      { code: 'TL', name: 'Timor-Leste' },
      { code: 'TK', name: 'Tokelau' },
      { code: 'TO', name: 'Tonga' },
      { code: 'TM', name: 'Turkmenistan' },
      { code: 'TV', name: 'Tuvalu' },
      { code: 'UM', name: 'United States Minor Outlying Islands' },
      { code: 'UZ', name: 'Uzbekistan' },
      { code: 'VU', name: 'Vanuatu' },
      { code: 'VN', name: 'Vietnam' },
      { code: 'WF', name: 'Wallis and Futuna' }
    ]
  },
  {
    name: 'Middle East',
    countries: [
      { code: 'BH', name: 'Bahrain' },
      { code: 'EG', name: 'Egypt' },
      { code: 'IR', name: 'Iran, (Islamic Republic of)' },
      { code: 'IQ', name: 'Iraq' },
      { code: 'IL', name: 'Israel' },
      { code: 'JO', name: 'Jordan' },
      { code: 'KW', name: 'Kuwait' },
      { code: 'LB', name: 'Lebanon' },
      { code: 'OM', name: 'Oman' },
      { code: 'PS', name: 'Palestinian Territory' },
      { code: 'QA', name: 'Qatar' },
      { code: 'SA', name: 'Saudi Arabia' },
      { code: 'SY', name: 'Syrian Arab Republic' },
      { code: 'TR', name: 'Turkey' },
      { code: 'AE', name: 'United Arab Emirates' },
      { code: 'YE', name: 'Yemen' }
    ]
  },
  {
    name: 'Africa',
    countries: [
      { code: 'DZ', name: 'Algeria' },
      { code: 'AO', name: 'Angola' },
      { code: 'BJ', name: 'Benin' },
      { code: 'BW', name: 'Botswana' },
      { code: 'IO', name: 'British Indian Ocean Territory' },
      { code: 'BF', name: 'Burkina Faso' },
      { code: 'BI', name: 'Burundi' },
      { code: 'CM', name: 'Cameroon' },
      { code: 'CV', name: 'Cape Verde' },
      { code: 'CF', name: 'Central African Republic' },
      { code: 'TD', name: 'Chad' },
      { code: 'KM', name: 'Comoros' },
      { code: 'CG', name: 'Congo' },
      { code: 'CD', name: 'Congo, (The Democratic Republic of the)' },
      { code: 'CI', name: 'Cote d\'Ivoire' },
      { code: 'DJ', name: 'Djibouti' },
      { code: 'GQ', name: 'Equatorial Guinea' },
      { code: 'ER', name: 'Eritrea' },
      { code: 'ET', name: 'Ethiopia' },
      { code: 'TF', name: 'French Southern Territories' },
      { code: 'GA', name: 'Gabon' },
      { code: 'GM', name: 'Gambia' },
      { code: 'GH', name: 'Ghana' },
      { code: 'GN', name: 'Guinea' },
      { code: 'GW', name: 'Guinea-Bissau' },
      { code: 'KE', name: 'Kenya' },
      { code: 'LS', name: 'Lesotho' },
      { code: 'LR', name: 'Liberia' },
      { code: 'LY', name: 'Libyan Arab Jamahiriya' },
      { code: 'MG', name: 'Madagascar' },
      { code: 'MW', name: 'Malawi' },
      { code: 'ML', name: 'Mali' },
      { code: 'MR', name: 'Mauritania' },
      { code: 'MU', name: 'Mauritius' },
      { code: 'YT', name: 'Mayotte' },
      { code: 'MA', name: 'Morocco' },
      { code: 'MZ', name: 'Mozambique' },
      { code: 'NA', name: 'Namibia' },
      { code: 'NE', name: 'Niger' },
      { code: 'NG', name: 'Nigeria' },
      { code: 'RE', name: 'Reunion' },
      { code: 'RW', name: 'Rwanda' },
      { code: 'SH', name: 'Saint Helena' },
      { code: 'ST', name: 'Sao Tome and Principe' },
      { code: 'SN', name: 'Senegal' },
      { code: 'SC', name: 'Seychelles' },
      { code: 'SL', name: 'Sierra Leone' },
      { code: 'SO', name: 'Somalia' },
      { code: 'ZA', name: 'South Africa' },
      { code: 'SS', name: 'South Sudan' },
      { code: 'SD', name: 'Sudan' },
      { code: 'SZ', name: 'Swaziland' },
      { code: 'TZ', name: 'Tanzania, (United Republic of)' },
      { code: 'TG', name: 'Togo' },
      { code: 'TN', name: 'Tunisia' },
      { code: 'UG', name: 'Uganda' },
      { code: 'EH', name: 'Western Sahara' },
      { code: 'ZM', name: 'Zambia' },
      { code: 'ZW', name: 'Zimbabwe' }
    ]
  },
  {
    name: 'Other',
    countries: [
    { code: 'AQ', name: 'Antarctica' }
    ]
  }
]
